<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="报备公司" prop="companyId" >
            <a-select v-model="form.companyId" placeholder="请选择" @change="queryPostList" >
              <a-select-option v-for="(company,index) in companyList" :key="index" :value="company.id">
                {{ company.companyName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="报备职位" prop="postId" >
            <a-select v-model="form.postId" placeholder="请选择" >
              <a-select-option v-for="(post,index) in postList" :key="index" :value="post.id">
                {{ post.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="面试时间" prop="interviewTime" >
            <a-date-picker
              style="width: 100%"
              v-model="form.interviewTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              show-time
              allow-clear/>
          </a-form-model-item>
          <a-form-model-item label="推荐官是否参与" prop="isReferralsTake" >
            <a-radio-group v-model="form.isReferralsTake">
              <a-radio value="0">否</a-radio>
              <a-radio value="1">是</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark" >
            <a-textarea :row="4" v-model="form.remark" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addReport } from '@/api/biz/user'
import { listCompany } from '@/api/user/company'
import { listCompanyPost } from '@/api/user/companyPost'
export default {
  name: 'FollowForm',
  props: {
    sexOptions: {
      type: Array,
    },
    isNoticeOptions: {
      type: Array,
    },
    statusOptions: {
      type: Array,
    }
  },
  components: {},
  data () {
    return {
      submitLoading: false,
      open: false,
      companyList: [],
      postList: [],
      formTitle: null,
      // 表单参数
      form: {
        id: null,
        userId: null,
        companyId: null,
        postId: null,
        interviewTime: null,
        isReferralsTake: 0,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      rules: {
        companyId: [
          { required: true, message: '报备公司不能为空', trigger: 'blur' }
        ],
        postId: [
          { required: true, message: '报备职位不能为空', trigger: 'blur' }
        ],
        interviewTime: [
          { required: true, message: '面试时间不能为空', trigger: 'blur' }
        ],
        isReferralsTake: [
          { required: true, message: '推荐官是否参与不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    queryCompanyList() {
      const param = {}
      listCompany(param).then(response => {
        this.companyList = response.data
      })
    },
    queryPostList() {
      const param = { companyId: this.form.companyId }
      listCompanyPost(param).then(response => {
        this.postList = response.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        companyId: null,
        postId: null,
        interviewTime: null,
        isReferralsTake: 0,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (id) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '报备'
      this.form.userId = id
      this.queryCompanyList()
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          addReport(this.form).then(response => {
            this.$message.success(
              '新增成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
